import React from 'react';
import { useSEO } from '../hooks/useSEO';

/**
 * SEO Manager component that handles global SEO updates
 * Must be used inside Router context
 */
const SEOManager: React.FC = () => {
  // Enable global SEO management
  useSEO();
  
  // This component doesn't render anything visible
  return null;
};

export default SEOManager;
